export default "__VITE_ASSET__f142cfce__"